import * as React from "react";
import { FormikProps } from "formik";
import { injectIntl, WrappedComponentProps, MessageDescriptor } from "react-intl";
import Dropdown from "@Elements/Dropdown/Dropdown";
import { DataOptions } from "@Safemate/DefaultSettings/Settings/FieldWrapper";
import withFormWrapper from "./formWrapper";
import { mapOptions, status, translateOptions } from "./utils";
import { SettingDiv, SettingHeader, TitleWrap } from "./styles";
import InformationIcon from "@Icons/Information1";
import Tooltip from "@Elements/Tooltip";
import { Option } from "@Elements/Dropdown/types";

interface DropdownOptions{
  prefix?: string;
  title?: MessageDescriptor;
  tooltip?: string;
  tooltipTitle?: MessageDescriptor
  padding?: boolean;
  width?: string;
  translate?: boolean;
  dataOptions: DataOptions;
  disableOptions?: DisableOptions;
  disabledAsControl?: boolean;
}

interface DisableOptions{
  name: string;
  prefix?: string;
  value: boolean;
}

interface DropdownProps<T> extends WrappedComponentProps{
  formik: FormikProps<T>; 
}

export function DropdownWrap(name: string, options: DropdownOptions): React.FunctionComponent<any>{
  return withFormWrapper(
    injectIntl(({intl: {formatMessage}, formik: {values, setFieldValue, setFieldTouched}}: DropdownProps<any>) => {

      let value;
      let field = name;
      if(options.prefix){
        value = values[options.prefix][name];
        field = `${options.prefix}.${name}`;
      }
      else{
        value = values[name];
      }
      
      let disable = false;

      if(options.disableOptions){
        let disableValue;
        let disableName = options.disableOptions.name;
        let disablePrefix = options.disableOptions.prefix; 
        if(disablePrefix){
          disableValue = values[disablePrefix][disableName];
        }
        else{
          disableValue = values[disableName];
        }
        if(disableValue === options.disableOptions.value){
          disable = true;
        }
      }

      let formattedData = options.dataOptions.options;
      if(options.dataOptions && !options.dataOptions.skipMap) {
        const { nullValue, offset } = options.dataOptions;
        formattedData = mapOptions(
          options.dataOptions.options, 
          formatMessage, 
          formatMessage(nullValue || status.disable), 
          offset,
          false,
          options.dataOptions.mapRoundDown
        );
      }
      
      if(options.dataOptions.translate){
        formattedData = translateOptions(formattedData, formatMessage);
      }

      const valueText = formattedData.find(opt => opt.value === value);

      return(
      <SettingDiv padding={options.padding} key={name}>
        {options.title &&
          <SettingHeader>
            <TitleWrap right>
              {breakAtParenthesis(formatMessage(options.title))}
            </TitleWrap>
            {options.tooltip &&
              <Tooltip
                popoverId={`${options.title}-popover`}
                labelId={options.tooltip}
                defaultMessage={options.tooltip}
                title={options.tooltipTitle ? formatMessage(options.tooltipTitle) : ""}
              >
                  <InformationIcon size="medium" />
              </Tooltip>
            }
          </SettingHeader>}
        {disable 
          ? (options.disabledAsControl
              ? <Dropdown
                  disabled
                  title={options.title ? formatMessage(options.title) : name}
                  options={formattedData}
                  initial={value}
                  size={{width: options.width}}
                  onChange={() => {}}
                />
              : <div>{`${valueText ? valueText.text : value}`}</div>)
          : <Dropdown
          disabled={disable}
          title={options.title ? formatMessage(options.title) : name}
          options={formattedData}
          initial={value}
          size={{width: options.width}}
          onChange={(object: Option | Option[]) => {
            const value = (object as Option).value;
            setFieldTouched(field)
            setFieldValue(field, value)
          }}
        />}
      </SettingDiv>)
    })
  ) as React.FunctionComponent<any>
}

const breakAtParenthesis = (text: string) => {
  const index = text.indexOf(" (");

  if (index === -1) return text;

  return (
    <>
      {text.slice(0, index)}
      <br />
      {text.slice(index)}
    </>
  );
};